import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Promotions from '@Header/Banners/PromotionBanner/Promotions';
import Impersonation from './Impersonation';
import { getShouldShowPromotionsBanner, selectIsImpersonating } from '../ducks/selectors';
import { getShouldShowCovid19Banner } from '../../utilities/bannersAndModals';
import UserNotificationBanner from './UserNotificationBanner';
import { userNotificationSelectors } from '../UserNotifications/ducks';
import OutageBanner from './OutageBanner';
import { outageBannerSelectors } from './OutageBanner/ducks';
import Covid19Banner from './Covid19Banner';
import Ie11Banner from './Ie11Banner/Ie11Banner';

class Banners extends React.Component {
  componentDidMount() {
    setTimeout(() => window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize'))));
  }

  render() {
    const {
      shouldShowPromotionsBanner,
      isImpersonating,
      environment,
      shouldShowUserNotificationBanner,
      shouldShowOutageBanner,
      shouldShowCovid19Banner
    } = this.props;
    const { userAgent } = window.navigator;
    const isBrowserIe11 = userAgent.match('Trident/7.0');
    return (
      <div data-type="header-banners">
        {shouldShowOutageBanner && <OutageBanner />}
        {isBrowserIe11 && <Ie11Banner />}
        {isImpersonating && <Impersonation />}
        {shouldShowCovid19Banner && <Covid19Banner key="covid19-banner" />}
        {shouldShowPromotionsBanner && <Promotions environment={environment} />}
        {shouldShowUserNotificationBanner && <UserNotificationBanner />}
      </div>
    );
  }
}

Banners.propTypes = {
  isImpersonating: PropTypes.bool,
  shouldShowCovid19Banner: PropTypes.bool,
  environment: PropTypes.string.isRequired,
  shouldShowUserNotificationBanner: PropTypes.bool.isRequired,
  shouldShowPromotionsBanner: PropTypes.bool.isRequired,
  shouldShowOutageBanner: PropTypes.bool.isRequired,
};

Banners.defaultProps = {
  isImpersonating: false,
};

const mapStateToProps = state => ({
  isImpersonating: selectIsImpersonating(state),
  shouldShowUserNotificationBanner: userNotificationSelectors.getShouldShowUserNotificationBanner(state),
  shouldShowPromotionsBanner: getShouldShowPromotionsBanner(state),
  shouldShowOutageBanner: outageBannerSelectors.getShouldDisplayOutageBannerOnPage(state),
  shouldShowCovid19Banner: getShouldShowCovid19Banner()
});

export default connect(mapStateToProps)(Banners);
